import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(40)}
    height={scaleSize(28)}
    viewBox="0 0 40 28"
  >
    <path
      fill="#CCC"
      fillRule="nonzero"
      d="M12.603 0h25.08a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2h-25.08a2 2 0 0 1-1.519-.698L.241 14.65a1 1 0 0 1 0-1.302L11.084.7A2 2 0 0 1 12.603 0zm13.08 11.596L20.086 6l-2.403 2.404L23.279 14l-5.596 5.596L20.086 22l5.597-5.596L31.279 22l2.404-2.404L28.086 14l5.597-5.596L31.279 6l-5.596 5.596z"
    />
  </svg>
);
